import React from 'react'
import { useFormContext } from "react-hook-form";
import FormStyle from "./fom.module.scss";
import TypoCss from '../../text/typography.module.scss';


function Input(props) {
  
  const { register } = useFormContext();

  const determineInputType = () => {
    switch (props.InputType) {

      case "input":
        return (
          <input
            placeholder={props.placeholder}
            {...register(`${props.name}`)}
            type={props.typeOfTheInput}
            className={`${FormStyle.tabclix_input_field} ${FormStyle.tabclix__w_input}`}
            maxLength={props.maxlength}
            name={props.name}
            data-name={props.dataName}
            id={props.idofInput}
            required={props.required}
          />
        );

      case "option":

        return (
          <select
            id={props.id}
            name={props.name}
            data-name={props.dataName}
            {...register(`${props.name}`)}
            className={`${FormStyle.tabclix_input_field} w-select`}
          >
            {props.inputOptions.map(function (opt) {
              if (opt.selected) {
                return (
                  <option value={opt.value} key={opt.value} selected>
                    {opt.content}
                  </option>
                );
              } else {
                return (
                  <option value={opt.value} key={opt.value}>
                    {opt.content}
                  </option>
                );
              }
            })}
          </select>
        );

      case "optgroup":
        const eactoptgroup = props.optgroup.map((group) =>
          <optgroup label={group.label} {...register(`${props.name}`)}>
            {group.options.map(opt => <option value={opt.value} key={opt.value}>{opt.content}</option>)}

          </optgroup>
          
        );

        return (
          <select
            className={`${FormStyle.tabclix_input_field} w-select`}
            {...register(`${props.name}`)}
          >
            {eactoptgroup}
          </select>
        );
    }
  }
  

  
  return (
    <div className="form-item-block">
      <label for={props.forLabel} className={`${TypoCss.tabclix__label}`}>{props.LabelName}</label>
      {determineInputType()}
      <div></div>
    </div>
  );
}

export default Input


//Version 1.0 with map options+parent is options
// import React from 'react'
// import { useSelector } from 'react-redux';

// function Input(props) {

//   const AllData = useSelector((state) => state.AllData)



//   const determineInputType = () => {
//     switch (props.InputType) {

//       case "input":
//         return (
//           <input
//             placeholder={props.placeholder}
//             type={props.typeOfTheInput}
//             class="input-field w-input"
//             maxlength={props.maxlength}
//             name={props.name}
//             data-name={props.dataName}
//             id={props.idofInput}
//             required={props.required}
//           />
//         );

//       case "option":
//         let optionsList = []

//         const findOption = AllData.map(function (eachObject) {
//           return eachObject.parent_ids.map(function (eachIdofeachComponent) {
//             if (eachIdofeachComponent === props.id) {
//               console.log(eachObject);
//               optionsList.push(eachObject)
//             }
//           })
//         })

//         console.log(findOption);
//         return (
//           <select
//             id={props.id}
//             name={props.name}
//             data-name={props.dataName}
//             class="input-field w-select">

//             {optionsList.map(opt => <option value={opt.value} key={opt.value}>{opt.content}</option>)}
//           </select>
//         );

//       case "optgroup":
//         const eactoptgroup = props.optgroup.map(group =>
//           <optgroup label={group.label}>
//             {group.options.map(opt => <option value={opt.value} key={opt.value}>{opt.content}</option>)}

//           </optgroup>
//         )
//         console.log(eactoptgroup)
//         return (
//           <select class="input-field w-select">
//             {eactoptgroup}
//           </select>
//         );

//     }
//   }

//   // console.log(props);
//   return (

//     <div class="form-item-block">
//       <label for={props.forLabel}>{props.LabelName}</label>
//       {determineInputType()}
//       <div>
//       </div>
//     </div>
//   )
// }

// export default Input